export const isModelLandingPage = (url = '') => {
  return url.match(/models\/(?:[^/]+\/)?([^/]+)\//);
};
